import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useTypewriterLoop from './useTypewriterLoop';
import MascotVideo from './MascotVideo';

const PILLS = [
  { label: 'Agendar diagnóstico', to: '/diagnostico-gratuito' },
  { label: 'Ver servicios', to: '/servicios' },
  { label: 'Hablar con un consultor', to: '/contacto' },
];

const SERVICES = [
  'Automatización de Procesos',
  'Agentes de Inteligencia Artificial',
  'Analítica de Datos',
  'Integración de Sistemas',
];

const TITLE_STYLE = {
  fontSize: 'clamp(30px, 5.6vw, 58px)',
  lineHeight: 1.15,
  fontWeight: 500,
  letterSpacing: '-0.01em',
};

const EMAIL = 'contacto@orbiax.co';

const CopyIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.5" y="3.5" width="7" height="7" rx="1" stroke="currentColor" />
    <rect x="1.5" y="1.5" width="7" height="7" rx="1" stroke="currentColor" />
  </svg>
);

const MainframeHero = () => {
  const [pillsVisible, setPillsVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const currentService = useTypewriterLoop(SERVICES, { typeSpeed: 55, deleteSpeed: 30, pauseTime: 1400, startDelay: 700 });

  useEffect(() => {
    const timeout = setTimeout(() => setPillsVisible(true), 400);
    return () => clearTimeout(timeout);
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard no disponible, no bloqueamos la interacción
    }
  };

  return (
    <section className="relative z-[1] pt-20 pb-12 md:flex md:flex-col md:h-screen md:justify-center md:pb-0 md:pt-0 px-5 sm:px-8 md:px-10 overflow-hidden">
      <MascotVideo />

      <div className="max-w-3xl relative z-10">
        {/* El typewriter de abajo cambia letra a letra, así que el h1 lleva
            la lista completa de servicios para lectores de pantalla y
            buscadores, y la línea animada queda aria-hidden. */}
        <h1 className="text-black m-0" style={TITLE_STYLE}>
          Transformamos Operaciones Complejas
          <span className="sr-only"> con {SERVICES.slice(0, -1).join(', ')} e {SERVICES[SERVICES.length - 1]}</span>
        </h1>

        <p className="text-black mb-5 sm:mb-6" style={{ ...TITLE_STYLE, minHeight: '1.15em' }} aria-hidden="true">
          {currentService}
          <span
            className="inline-block w-[2px] h-[0.9em] bg-black align-middle ml-[2px]"
            style={{ animation: 'blink 1s step-end infinite' }}
          />
        </p>

        <p
          className="text-black/70 mb-6 sm:mb-8 max-w-xl"
          style={{ fontSize: 'clamp(15px, 2vw, 18px)', lineHeight: 1.5, fontWeight: 400 }}
        >
          No necesitas otro software genérico. Diseñamos, automatizamos y desplegamos soluciones
          tecnológicas con Inteligencia Artificial que resuelven cuellos de botella reales en tu
          empresa.
        </p>

        <div
          className="flex flex-wrap gap-y-1"
          style={{
            opacity: pillsVisible ? 1 : 0,
            transform: pillsVisible ? 'translateY(0)' : 'translateY(8px)',
            transition: 'opacity 0.4s ease, transform 0.4s ease',
          }}
        >
          {PILLS.map((pill) =>
            pill.to ? (
              <Link
                key={pill.label}
                to={pill.to}
                className="inline-flex items-center justify-center bg-white text-black border border-black/10 rounded-full text-[13px] sm:text-[15px] px-4 sm:px-5 py-[0.3em] mx-[0.2em] mb-[0.4em] whitespace-nowrap hover:bg-black hover:text-white transition-colors duration-200"
              >
                {pill.label}
              </Link>
            ) : (
              <a
                key={pill.label}
                href={pill.href}
                className="inline-flex items-center justify-center bg-white text-black border border-black/10 rounded-full text-[13px] sm:text-[15px] px-4 sm:px-5 py-[0.3em] mx-[0.2em] mb-[0.4em] whitespace-nowrap hover:bg-black hover:text-white transition-colors duration-200"
              >
                {pill.label}
              </a>
            )
          )}

          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex items-center justify-center gap-2 sm:gap-3 text-black bg-transparent border border-black rounded-full text-[13px] sm:text-[15px] px-4 sm:px-5 py-[0.3em] mx-[0.2em] mb-[0.4em] whitespace-nowrap hover:bg-black hover:text-white transition-colors duration-200"
          >
            <span>
              Escríbenos: <span className="underline underline-offset-1">{EMAIL}</span>
            </span>
            <CopyIcon />
            {copied && <span className="text-[11px]">¡Copiado!</span>}
          </button>
        </div>
      </div>
    </section>
  );
};

export default MainframeHero;
